import { Table } from '@/main/utils/table';
import { DropdownItem, DropdownList, MultiSelectItem } from '@/main/store/@types/dropdown.d';

export class Edit {
	// UdajeOFirme
	Firma: string | null = null;
	ProvozovnaZkt: string | null = null;
	Text: string | null = null;
	DicNr: string | null = null;
	IcoNr: string | null = null;
	IcDphNr: string | null = null;
	Ulice: string | null = null;
	Obec: string | null = null;
	PscNr: string | null = null;
	StatId: number | null = null;
	MenaId2: number | null = null;
	WwwAdresa: string | null = null;
	FirmasidloIdText: string | null = null;
	VyrazenPrp: boolean | null = null;
	DodavatelId: number | null = null;
	DodavatelIdText: string | null = null;
	BankucetIdText: string | null = null;
	BankaUcet: string | null = null;
	BankaIban: string | null = null;
	BankaBic: string | null = null;
	BankucetId2Text: string | null = null;
	BankaUcet2: string | null = null;
	BankaIban2: string | null = null;
	BankaBic2: string | null = null;
	TelfmaNr: string | null = null;
	TelmobNr: string | null = null;
	FaxNr: string | null = null;
	TelsmNr: string | null = null;
	TelnvNr: string | null = null;
	TelovNr: string | null = null;
	TelskladNr: string | null = null;
	EMailAdresa: string | null = null;
	IntrZakaznikId: number | null = null;
	IntrZakaznikIdText: string | null = null;
	NonstopServisTxt: string | null = null;
	NonstopServisTelNr: string | null = null;
	Gstin: string | null = null;
	PrimaryEmail: string | null = null;
	GracePeriod: number | null = null;
	NoShowPeriod: number | null = null;
	SaReceptionSlot: number | null = null;
	SaDeliverySlot: number | null = null;
	PlannerStartTime: string | null = null;
	PlannerEndTime: string | null = null;
	LunchStartTime: string | null = null;
	LunchEndTime: string | null = null;
	AppointmentSplitTime: string | null = null;
	WeeklyOffId: MultiSelectItem[] = [];
	ScheduleId: number | null = null;
	BulkInventoryPrp: boolean | null = null;

	// FirmaNastaveni1
	HotovostKonto: number | null = null;
	HospRokKon: string | null = null;
	KlientNr: string | null = null;
	DokladSk: number | null = null;
	NvIncDphszbozn: number | null = null;
	DrMatSzb: number | null = null;
	DrMatMax: number | null = null;
	DrMatText: string | null = null;
	DrMatLimit: number | null = null;
	DrMatMin: number | null = null;
	DrMatDphszbozn: boolean | null = null;
	NdsprijNcDifMin: number | null = null;
	NdsprijNcDifMax: number | null = null;
	NdsdobrNcDifMin: number | null = null;
	NdsdobrNcDifMax: number | null = null;
	NdpcvydejFluktSzb: number | null = null;
	ApGdId: number | null = null;
	ApGdIdText: string | null = null;
	ApSkladOzn: number | null = null;
	ZkrdandokLimit: number | null = null;
	EshopSkladOzn: number | null = null;
	FibuFirmaNr: number | null = null;
	FibuDruh: string | null = null;
	FibuPrpt: boolean | null = null;
	IntrDruhPrp: boolean | null = null;
	IntrDruhNsPrp: boolean | null = null;
	IntrDruhOzn: number | null = null;
	IntrDruhOznText: string | null = null;
	SkladPrevodIntrDruhOzn: number | null = null;
	SkladPrevodIntrDruhOznText: string | null = null;
	ZakaznikintSk: number | null = null;
	SkladPrevodZakaznikintSk: number | null = null;
	NvMarzeZakladSzb: number | null = null;
	NvPodporyCelkSzb: number | null = null;
	NvBonusCelkSzb: number | null = null;

	// FirmaNastaveni2
	BezdphDphszbozn: number | null = null;
	ZalohaDphszbozn: number | null = null;
	PnvzalohaPzn: number | null = null;
	PnvkorekcePzn: number | null = null;
	PenaleDphszbozn: number | null = null;
	ZakzalohaPzn: number | null = null;
	PovzalohaPzn: number | null = null;
	PovkorekcePzn: number | null = null;
	DphkalkZao: number | null = null;
	PnvZakaznikSk: number | null = null;
	TemplsadaId: number | null = null;
	TemplsadaIdMso07: number | null = null;
	PneuprotvydPrp: boolean | null = null;
	PneuprvydprePrp: boolean | null = null;
	IbsMarketkod: number | null = null;
	IbsMarketkodTxt: string | null = null;
	ZlTextvoln: string | null = null;
	EmiseSmeNr: string | null = null;
	EmiseAlertDni: number | null = null;
	PmOzakazkobjPtPro: number | null = null;
	SnPcCelkRezPrc: number | null = null;
	EdiCode: string | null = null;
	SnPcCelkRez: number | null = null;

	// AplikaceNastaveni
	VymGarInl: number | null = null;
	VymZakazkaInl: number | null = null;
	VyrazNdInl: number | null = null;
	ProvozovnaPfx: number | null = null;
	GarlhunotifInl: number | null = null;
	AutomVymazSklKartyPrp: boolean | null = null;
	ProtPrp: boolean | null = null;
	PrumerkaPrp: boolean | null = null;
	RegpoklPrp: boolean | null = null;
	SkodanrKonPrp: boolean | null = null;
	UctoPcSlPrp: boolean | null = null;
	VydejkaPrpt: boolean | null = null;
	EfibPrp: boolean | null = null;
	PnvminusPrp: boolean | null = null;
	PcsdphviewPrp: boolean | null = null;
	ScZobrPrp: boolean | null = null;
	PrijemkanvPrpt: boolean | null = null;
	VydejkanvPrpt: boolean | null = null;
	VymazKartyBezZmLokacePrp: boolean | null = null;
	NvskladprePrpt: boolean | null = null;
	TankomatPrp: boolean | null = null;
	LexExclPrp: boolean | null = null;
	LakdruhPrp: boolean | null = null;
	SlevasumPrp: boolean | null = null;
	VydejkaprePrpt: boolean | null = null;
	DzmPrp: string | null = null;
	ScDecimPrp: boolean | null = null;
	PrijemkaovPrpt: boolean | null = null;
	VydejkaovPrpt: boolean | null = null;
	NahradaautPrp: boolean | null = null;
	Zl2strPrpt: boolean | null = null;
	NcKorPrp: boolean | null = null;
	PpAutomPrp: number | null = null;
	VydejkakumulPrpt: boolean | null = null;
	ZakpobocPrp: boolean | null = null;
	JmhExpPrp: boolean | null = null;
	PovminusPrp: boolean | null = null;
	VyhodmechHcvPrp: boolean | null = null;
	PujcpaVrPrp: boolean | null = null;
	NvPredaniPrp: boolean | null = null;
	RegistraceTxt: string | null = null;

	// GrafLoga
	LogoSk: number | null = null;
	SmLogoSk: number | null = null;
	EmiseLogoSk: string | null = null;
	GdprLogoSk: number | null = null;
	LogoId: number | null = null;

	BankaPrezPzn: number | null = null;
	BankucetId: number | null = null;
	BankucetId2: number | null = null;
	EditDat: string | null = null;
	EditPracId: number | null = null;
	EetCert: string | null = null;
	EetCertPassw: string | null = null;
	EetIdProvoz: number | null = null;
	FirmasidloId: number | null = null;
	OrganizaceId: number | null = null;
	PdfCertId: number | null = null;
	PdfSignatureDuvod: string | null = null;
	PdfSignaturePrp: boolean | null = null;
	ProvozovnaId: number | null = null;
	RpzvOrgName: string | null = null;
	VstupDat: string | null = null;
	VstupPracId: number | null = null;
	Operations: number = 0;

	// DealerKVPS
	OrgUnitId: number | null = null;
	DealerKvpsCode: string | null = null;
	OrgUnitText:string | null = null;
}

export class LocalState {
	ServPersProvozTable: Table | null = null;
	FleetCentrumTable: Table | null = null;
	SpecialistaNehodyTable: Table | null = null;
	headers: Record<string, string> = {
		fleetCentrum: '',
		certSpecOprav: '',
	};
}

export class ProvozovnaDropdownList implements DropdownList {
	DphSazbaOzn = [];
	Stat = [];
	MenaKod = [];
	DokladSk = [];
	Sklad = [];
	PnvZaloha = [];
	PnvKorekce = [];
	ZakZaloha = [];
	PovKorekce = [];
	TemplSada = [];
	ZakaznikSk2 = [];
	DmsLogo = [];
	DmsLogoSk = [];
	BankaPrezPzn = [];
	WeeklyOff = [];
	Schedules = [];
	[key: string]: DropdownItem[];
}
